<template>

  <BasicLayout>
    <!-- <SportIcons class="section" :id="id"></SportIcons> -->
    <SportOrder class="section" :id="id"></SportOrder>
    <SportLabels class="section" :id="id"></SportLabels>
    <SportFederations class="section" :id="id"></SportFederations>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import SportIcons from './SportIcons'
import SportLabels from './SportLabels'
import SportFederations from './SportFederations'
import SportOrder from './SportOrder'

export default {
  name: 'SportPage',
  components: {
    BasicLayout,
    SportIcons,
    SportLabels,
    SportOrder,
    SportFederations
  },
  data () {
    return {
      id: this.$route.params.id,
      loadingSport: true,
      loadingFederations: true
    }
  },
  mounted () {
    this.$store.dispatch('getSport', this.id)
      .catch(err => {
        console.error(err)
      })
      .then(() => {
        this.loadingSport = false
      })

    this.$store.dispatch('getSportFederations', this.id)
      .catch(err => {
        console.error(err)
      })
      .then(() => {
        this.loadingFederations = false
      })
  }
}

</script>

<style lang="scss" scoped>

.section {
  margin-bottom: 30px;
}

</style>



// WEBPACK FOOTER //
// src/pages/sport/Sport.vue